import { withI18n } from '@lingui/react'
import classNames from 'classnames'
import { bool, oneOf, string } from 'prop-types'

import {
  AVAILABLE_PRODUCT_TEMPLATES,
  DEFAULT_PRESCRIPTION_TYPE,
  PRODUCT_TEMPLATES,
} from 'shared/consts/productTemplates'
import Select from 'views/components/molecules/Select'
import { i18nType } from 'views/utils/propTypes'

import { getPrescriptionTypeLabels } from './helpers'

import './PrescriptionTypeBox.scss'

const PrescriptionTypeBox = ({
  mobile,
  productTemplate,
  selectedPrescriptionType,
  floatingLabel,
  label,
  showLabel,
  i18n,
}) => {
  let displayedLabel = label
  if (!displayedLabel) {
    displayedLabel = mobile
      ? i18n._('product.prescription.choosePrescriptionLong')
      : i18n._('product.prescription.choosePrescriptionShort')
  }

  const id = `prescription_type${mobile ? '-mobile' : ''}`
  const prescriptionTypeBoxClasses = classNames({
    'o-PrescriptionTypeBox--small-tiny a-box a-box--dark u-margin--bottom@small-tiny':
      mobile,
    'o-PrescriptionTypeBox__select-wrapper': !mobile,
  })

  const selectedValue =
    selectedPrescriptionType || DEFAULT_PRESCRIPTION_TYPE[productTemplate]
  const options = getPrescriptionTypeLabels(i18n, productTemplate)

  return (
    <div
      className={prescriptionTypeBoxClasses}
      data-clientside-hook="h-ProductVariants-trigger"
    >
      <Select
        id={id}
        name="prescriptionType"
        label={displayedLabel}
        selectedValue={selectedValue}
        showLabel={showLabel}
        options={options}
        floatingLabel={floatingLabel}
      />
    </div>
  )
}

PrescriptionTypeBox.propTypes = {
  productTemplate: oneOf(AVAILABLE_PRODUCT_TEMPLATES),
  i18n: i18nType.isRequired,
  selectedPrescriptionType: string,
  mobile: bool,
  label: string,
  showLabel: bool,
  floatingLabel: bool,
}

PrescriptionTypeBox.defaultProps = {
  productTemplate: PRODUCT_TEMPLATES.OTC,
  selectedPrescriptionType: null,
  mobile: false,
  label: null,
  showLabel: false,
  floatingLabel: false,
}

export default withI18n()(PrescriptionTypeBox)
